<template>
  <aicc-page :pageId="this.contextPageId">
    <ur-area>
      <div class="wrap">
        <div class="contents_wrap">
          <section>
            <div class="contents manage_campaign">
              <div>
                <ur-form-box toggleable column="5">
                  <ur-form-row>
                    <ur-form-item
                      :label="$t('MSG_TXT_CAMPAIGN_PERIOD')"
                      labelAlign="right"
                      colSpan="2"
                    >
                      <aicc-range-picker
                        v-model="rangeDateValue"
                        autoConfirm
                        inputType="YYYY-MM-DD"
                        modelType="YYYY-MM-DD"
                        Name
                        cancelLabel="취소"
                        confirmLabel="확인"
                        init="none"
                      />
                    </ur-form-item>

                    <ur-form-item
                      :label="$t('MSG_TXT_CAMPAIGN')"
                      labelAlign="right"
                      colSpan="2"
                    >
                      <autoMultiDropdown
                        v-model="campaignValue"
                        applyBtn
                        selectAll
                        selectedAllText="전체"
                        :itemsSize="300"
                        :items="campaignItems"
                        placeholder="전체"
                      />
                    </ur-form-item>
                  </ur-form-row>

                  <ur-form-row>
                    <ur-form-item label="상태" labelAlign="right" colSpan="2">
                      <autoMultiDropdown
                        v-model="statusValue"
                        applyBtn
                        selectAll
                        selectedAllText="전체"
                        :itemsSize="300"
                        :items="statusItems"
                        placeholder="전체"
                      />
                    </ur-form-item>

                    <ur-form-item
                      label="발신번호"
                      labelAlign="right"
                      colSpan="2"
                    >
                      <ur-dropdown
                        @input="onInputSipNumber"
                        v-model="sipNumberValue"
                        style="width: 300px"
                        :items="sipNumberItems"
                        placeholder="전체"
                      />
                    </ur-form-item>

                    <ur-form-item no-label noFlex>
                      <!-- <ur-button v-if="this.page.totalItems === 0" @click="clearSearchParams">초기화</ur-button> -->
                      <ur-button
                        shape="solid"
                        primary
                        @click="getOutCallScheduleList"
                        >조회</ur-button
                      >
                    </ur-form-item>
                  </ur-form-row>
                </ur-form-box>
              </div>

              <div class="data_tbl_list">
                <ur-data-grid
                  :headers="scheduleListColumns"
                  :options="scheduleListOptions"
                  :data-source="scheduleDataList"
                  @grid:click="onCampaignClick"
                  ref="scheduleListGrid"
                >
                  <template #right-info>
                    <ur-button
                      shape="solid"
                      color="white"
                      @click="onClickDownload"
                      >데이터 다운로드</ur-button
                    >
                    <ur-button primary large @click="registerOutCallSchedule"
                      ><i class="new_campagin_icon" />{{
                        $t("MSG_BTN_NEW_CAMPAIGN")
                      }}</ur-button
                    >
                  </template>
                </ur-data-grid>
              </div>

              <!-- Csv 다운로드용 hidden data grid -->
              <div class="data_tbl_list" hidden>
                <ur-data-grid
                  :headers="csvHeaders"
                  :data-source="csvDataList"
                  ref="csvGrid"
                />
              </div>
              <!-- <ur-pagination :pagination="page" @move="changeCurrentPage" /> -->
            </div>
          </section>
        </div>
      </div>

      <div>
        <ur-snackbar ref="snackbar" :duration="3000"></ur-snackbar>
      </div>

      <!-- <schedule-detail-popup ref="scheduleDetailPopup" :pageId="contextPageId" :tabIdx="tabIdx" :scheduleId="scheduleId"/> -->
      <schedule-detail-popup
        ref="scheduleDetailPopup"
        :pageId="contextPageId"
        :pageInitialData="pageInitialData"
        @closeDetailPopup="closeDetailPopup"
        @reLoadScheduleList="reLoadScheduleList"
      />
    </ur-area>
  </aicc-page>
</template>

<script>
import BasePage from "~cm/components/BasePage";
import { urDataSet } from "uidev-component/index.js";
import urDataGrid from "@uidev/grid/urDataGrid/urDataGrid";

import autoMultiDropdown from "../../components/CMP_AIC_00001.vue";
import urCustomDropHolder from "../../components/CMP_AIC_00002.vue";

import scheduleDetailPopup from "../../components/CMP_AIC_00005/CMP_AIC_00005.vue";

if (!window.PGE_AIC_00004_POPUPMAP) {
  window.PGE_AIC_00004_POPUPMAP = new Map();
}

// window.setOutCallSchduleInfoFromChild = function (mode, data) {
//   // console.log("PGE_AIC_00004: setOutCallSchduleInfoFromChild Called.", mode, data)
//   modeValueFromChild = mode;
//   outCallSchduleInfoFromChild = data;
// }
// window.getOutCallSchduleInfoFromChild = function() {
//   return outCallSchduleInfoFromChild;
// }
// window.getModeValueFromChild = function(){
//   return modeValueFromChild;
// }

// 아래 변수는 캠페인 입력,수정,복사 팝업에서 세팅하는 변수 이름으로 참고용으로 남겨 놓는다.
var modeValueFromChild;
var outCallSchduleInfoFromChild;

export default {
  name: "PGE_AIC_00004",
  extends: BasePage,
  components: {
    urDataGrid,
    autoMultiDropdown: autoMultiDropdown,
    urCustomDropHolder,
    scheduleDetailPopup,
  },

  data() {
    return {
      scheduleListDataSet: new urDataSet(),
      scheduleListOptions: {
        height: 640,
        infinityScroll: true,
        msgTotal: "총 #",
        msgAscending: "오름차순 정렬",
        msgDescending: "내림차순 정렬",
        msgEmptyData: "",
      },
      scheduleListColumns: [
        {
          value: "scheduleStatusName",
          text: this.$i18n.t("MSG_TXT_STATUS"),
          width: 96,
          sort: true,
          key: true,
          component: {
            props: ["row", "value", "text"],
            template: `<span><strong :class="statusClass(row)">{{text}}</strong></span>`,
            data() {
              return {
                scheduleStatusClass: {
                  A: "status waiting",
                  B: "status waiting",
                  C: "status ing",
                  D: "status done",
                  E: "status cancel",
                  F: "status cancel",
                  G: "status cancel",
                  H: "status cancel",
                },
              };
            },
            computed: {
              statusClass() {
                return (row) => {
                  return this.scheduleStatusClass[this.row.scheduleStatus];
                };
              },
            },
          },
        },
        {
          value: "scheduleName",
          text: this.$i18n.t("MSG_TXT_CAMPAIGN"),
          sort: true,
        },
        {
          value: "schedulePeriod",
          text: this.$i18n.t("MSG_TXT_CAMPAIGN_PERIOD"),
          width: 192,
          sort: true,
        },
        {
          value: "sipNumber",
          text: this.$i18n.t("MSG_TXT_SIP_NUMBER"),
          width: 160,
          sort: true,
        },
        {
          value: "senarioDescription",
          text: this.$i18n.t("MSG_TXT_SCENARIO"),
          sort: true,
        },
        {
          value: "calleeCount",
          text: this.$i18n.t("MSG_TXT_CALLEE_COUNT"),
          width: 96,
          sort: true,
          component: {
            props: ["row", "value", "text"],
            template: `<span>{{text}}건</span>`,
          },
        },
        {
          value: " ",
          text: " ",
          width: 40,
          component: {
            props: ["row", "value", "text"],
            template: `<aicc-icon-drop-holder :items="dropHolderItems(row)" :v-model="dropHolderValue" @input="dropHolderInput">
                            <ur-button class="btn_more"/>
                          </aicc-icon-drop-holder>`,
            data() {
              return {
                dropHolderValue: {},
              };
            },
            computed: {
              dropHolderItems() {
                return (row) => {
                  // 1. 캠페인 상태에 따라 노출되는 항목 상이 (최종정의 : 작성중/대기중/진행중/중지/취소/완료/시스템중지(G)/시스템취소(H))
                  // - 작성중(A), 대기중(B) : 수정, 삭제
                  // - 진행중(C) : 복사, 중지
                  // - 중지(E) : 수정, 다시 진행, 취소, 복사
                  // - 완료(D), 취소(F) : 복사
                  // 2. 수정, 중지, 취소는 Manager 이상 혹은 작성자 User 限 노출
                  // 3. 시스템중지(G)/시스템취소(H) 복사 가능
                  // console.log(this.$store.getters.userInfo)
                  let isSamePerson =
                    this.$store.getters.userInfo.userId === row.userId;
                  let isManager = aiccCode.UserGroup.isManager(
                    this.$store.getters.userInfo.userGroupId
                  );

                  let dropHolderItems = [];
                  let scheduleInfo = {};

                  scheduleInfo.scheduleId = row.scheduleId;
                  scheduleInfo.scheduleStatus = row.scheduleStatus;
                  scheduleInfo.userId = row.userId;
                  scheduleInfo.scheduleName = row.scheduleName;

                  dropHolderItems.push({
                    value: { action: "detail", scheduleInfo },
                    text: "상세 조회",
                    iconType: "list",
                  });
                  dropHolderItems.push({ isSeparator: true });

                  if (
                    "ABE".includes(row.scheduleStatus) &&
                    (isSamePerson || isManager)
                  ) {
                    dropHolderItems.push({
                      value: { action: "modify", scheduleInfo },
                      text: "캠페인 수정",
                      iconType: "modify",
                    });
                  }

                  if (
                    "AB".includes(row.scheduleStatus) &&
                    (isSamePerson || isManager)
                  ) {
                    dropHolderItems.push({
                      value: { action: "delete", scheduleInfo },
                      text: "캠페인 삭제",
                      iconType: "trash",
                    });
                  }

                  if ("CDEFGH".includes(row.scheduleStatus)) {
                    dropHolderItems.push({
                      value: { action: "copy", scheduleInfo },
                      text: "캠페인 복사",
                      iconType: "copy",
                    });
                  }

                  if (
                    "C".includes(row.scheduleStatus) &&
                    (isSamePerson || isManager)
                  ) {
                    dropHolderItems.push({
                      value: { action: "pause", scheduleInfo },
                      text: "캠페인 중지",
                      iconType: "pause",
                    });
                  }

                  if ("E".includes(row.scheduleStatus)) {
                    dropHolderItems.push({
                      value: { action: "replay", scheduleInfo },
                      text: "캠페인 다시 진행",
                      iconType: "replay",
                    });
                  }

                  if (
                    "E".includes(row.scheduleStatus) &&
                    (isSamePerson || isManager)
                  ) {
                    dropHolderItems.push({
                      value: { action: "cancel", scheduleInfo },
                      text: "캠페인 취소",
                      iconType: "cancel",
                    });
                  }

                  return dropHolderItems;
                };
              },
            },
            methods: {
              dropHolderInput(value) {
                let parent = this.getComponent("PGE_AIC_00004");
                parent.moreMenuSelected(value);
              },
              getComponent(name) {
                let component = null;
                let thisComponent = this;
                while (thisComponent && !component) {
                  if (thisComponent.$options.name === name) {
                    component = thisComponent;
                    break;
                  }
                  thisComponent = thisComponent.$parent;
                }
                return component;
              },
            },
          },
        },
      ],

      // ur-table
      scheduleDataList: [],

      rangeDateValue: ["", ""],
      startDateValue: "",
      endDateValue: "",

      outCallSchedule: {
        scheduleId: "",
      },

      outCallScheduleAsk: {
        scheduleId: "",
      },

      outCallSchedulesAsk: {
        startDate: "",
        endDate: "",
        scheduleIdList: [],
        sipNumberList: [],
        scheduleStatusList: [],
      },

      outCallScheduleDeleteAsk: {},
      outCallScheduleStatusUpdateAsk: {},

      campaignValue: [],
      campaignDropdown: [],

      statusValue: [],
      statusDropdown: [],

      sipNumberValue: "",
      sipNumberDropdown: [],
      sipNumberSet: new Set(),

      // CSV 다운로드용 헤더
      csvHeaders: [
        {
          text: this.$i18n.t("MSG_TXT_STATUS"),
          value: "scheduleStatusName",
          width: "96px",
          sortable: false,
        },
        {
          text: this.$i18n.t("MSG_TXT_CAMPAIGN_NAME"),
          value: "scheduleName",
          sortable: false,
        },
        {
          text: this.$i18n.t("MSG_TXT_CAMPAIGN_PERIOD"),
          value: "schedulePeriod",
          width: "216px",
          sortable: false,
        },
        {
          text: this.$i18n.t("MSG_TXT_SIP_NUMBER"),
          value: "sipNumber",
          width: "160px",
          sortable: true,
        },
        {
          text: this.$i18n.t("MSG_TXT_SCENARIO"),
          value: "senarioDescription",
          width: "416px",
          sortable: false,
        },
        {
          text: this.$i18n.t("MSG_TXT_CALLEE_COUNT"),
          value: "calleeCount",
          width: "98px",
          sortable: false,
        },
        {
          text: this.$i18n.t("MSG_TXT_DETAIL_CNTN"),
          value: "scheduleDescription",
          width: "60px",
          sortable: true,
        },
        {
          text: this.$i18n.t("MSG_TXT_RGST_DT"),
          value: "insertDate",
          width: "20px",
          sortable: true,
        },
        {
          text: this.$i18n.t("MSG_TXT_MODIFY_DT"),
          value: "updateDate",
          width: "20px",
          sortable: true,
        },
        {
          text: this.$i18n.t("MSG_TXT_RGST_USR"),
          value: "userNm",
          width: "15px",
          sortable: true,
        },
      ],
      csvDataList: [],

      page: {
        rowsPerPage: 10,
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
      },

      registerPopupWindow: null,
      copyPopupWindow: null,

      updatePopupWindow: null,
      updatePopupWindowMap: null,

      statusOngoing: false,
      clickedScheduleId: "",
      clickedScheduleStatus: "",
      clickedUserId: "",
      clickedScheduleName: "",

      statusDropHolder: [],
      dropHolderValue: {
        action: "",
        scheduleInfo: {
          scheduleId: "",
          scheduleStatus: "",
          userId: "",
          scheduleName: "",
        },
      },

      pageInitialData: {},
      outCallStatistics: {},

      tabIdx: 0,
      scheduleId: "",
      scheduleTitle: "",

      modeValue: "",
      isFirstTime: false,
    };
  },

  created() {
    /*
    if(window.aiccEventBus && !window.aiccEventBus._events["PGE_AIC_00004-event"]) {
      window.aiccEventBus.$on('PGE_AIC_00004-event', value => this.moreMenuSelected(value));
    }
    */
  },

  computed: {
    campaignItems() {
      return this.campaignDropdown;
    },
    statusItems() {
      return this.statusDropdown;
    },
    sipNumberItems() {
      return this.sipNumberDropdown;
    },

    modal() {
      return this.$refs.modal;
    },
  },

  watch: {
    rangeDateValue: function (newVal, oldVal) {
      this.scheduleListOptions.msgEmptyData = "";
      this.$refs["scheduleListGrid"].updateOptions(this.scheduleListOptions);
      this.clearSearchParams();

      // 화면 상단 캠페인 DropDown과 sipNumber dropdown을 다시 채운다.
      // 화면 하단 리스트는 갱신하지 않기 때문에 isFirstTiem은 false 한다.
      this.isFirstTiem = false;
      this.getSearchParamsData();
    },
  },

  mounted() {
    this.scheduleListOptions.height =
      $(".ur-area").css("height").replace("px", "") - 265;
    window.addEventListener("resize", this.handleResize);
    this.updatePopupWindowMap = window.PGE_AIC_00004_POPUPMAP;

    this.initializeRangePickerValue();
    this.clearSearchParams();

    // 화면 상단 캠페인 DropDown과 sipNumber dropdown을 채운다.
    // 처음 화면에 진입한 경우는 getSearchParamsData 함수내 getOutCallScheduleList 함수도 호출하기 위해 isFirstTime을 true로 만든다.
    this.isFirstTime = true;
    this.getSearchParamsData();
  },

  beforeUpdate() {},

  updated() {},

  beforeDestroy() {
    //window.aiccEventBus.$off("PGE_AIC_00004-event");
    window.removeEventListener("resize", this.handleResize);
  },

  destroyed() {},

  methods: {
    showSnackbar(message) {
      this.$refs.snackbar.show({ text: message });
    },

    handleResize(event) {
      this.$nextTick(() => {
        this.scheduleListOptions.height =
          $(".ur-area").css("height").replace("px", "") - 265;
      });
    },

    onInputSipNumber() {},

    onCampaignClick(cell, row, field, event) {
      if (typeof event === "object") {
        if (event.button === 0) {
          // 마우스 메인 버튼만 유효
          // drop holder를 클릭한 경우는 field.value 가 빈값이다.
          if (!utils.isEmpty(field.value.trim())) {
            let scheduleInfo = {};
            scheduleInfo.scheduleId = row.scheduleId;
            scheduleInfo.scheduleName = row.scheduleName;
            scheduleInfo.scheduleStatus = row.scheduleStatus;
            this.showScheduleDetail(scheduleInfo);
          }
        }
      }
    },

    closeDetailPopup() {
      // console.log('closeDetailPopup() is called.');

      // PGE_AIC_0004(목록) -> CMP_AIC_0005(상세조회 모달) -> 입력, 수정, 복사(PGE_AIC_00003) 순서로 호출되는 경우
      //  -> 입력, 수정, 복사(PGE_AIC_00003) 완료하면 modeValueFromChild, outCallSchduleInfoFromChild 값 세팅후 팝업 윈도우가 닫히고
      //  -> CMP_AIC_0005(상세조회 모달)이 닫히고 emit 으로 'closeDetailPopup'을 넘긴다.
      //  -> PGE_AIC_0004(목록)에서는 showMsgAfterChildClosed 함수에서 modeValueFromChild 값에 따라서 토스트 메시지를 보여준다.

      // PGE_AIC_0004(목록) -> CMP_AIC_0005(상세조회 모달) 에서 상태를 바꾼 경우는
      // CMP_AIC_0005(상세조회 모달)에서 상태 변경 메시지를 보여 주고 modeValueFromChild, outCallSchduleInfoFromChild 값 세팅하고 상세조회 모달은 떠 있게 된다.
      // 이후 상세조회 모달 화면내 '확인' 버튼 누르면 emit 으로 'closeDetailPopup'을 넘긴다.

      // PGE_AIC_0004(목록) -> CMP_AIC_0005(상세조회 모달) 에서 캠페인 삭제하는 경우는
      // CMP_AIC_0005(상세조회 모달) 에서 확인 메시지 박스 보여주고 메시지 박스에서 '확인' 하면
      // modeValueFromChild, outCallSchduleInfoFromChild 값 세팅하고 emit 으로 'closeDetailPopup'을 넘긴다.

      this.showMsgAfterChildClosed();
    },

    reLoadScheduleList(scheduleId, scheduleStatus) {
      // console.log(scheduleId, scheduleStatus, '상태값 바꿔야 함')
      for (var schedule of this.scheduleDataList) {
        if (schedule.scheduleId === scheduleId) {
          schedule.scheduleStatus = scheduleStatus;
          schedule.scheduleStatusName =
            aiccCode.scheduleStatus.codeText(scheduleStatus);
          break;
        }
      }
      this.$refs["scheduleListGrid"].setData(this.scheduleDataList);
    },

    getSearchParamsData() {
      // 수행일정 validation false시 그냥 리턴한다.
      if (!this.onInputDateCheck()) {
        return;
      }

      // 수행일정 변경에 따라 캠페인 dropdown 과 sipNumber dropdown을 다시 채울때는 날짜만으로 캠페인 리스트를 가져온다.
      this.outCallSchedulesAsk.startDate = utils.toStringByFormat(
        utils.toDate(this.rangeDateValue[0]),
        "YYYYMMDD"
      );
      this.outCallSchedulesAsk.endDate = utils.toStringByFormat(
        utils.toDate(this.rangeDateValue[1]),
        "YYYYMMDD"
      );
      this.outCallSchedulesAsk.scheduleIdList = [];
      this.outCallSchedulesAsk.sipNumberList = [];
      this.outCallSchedulesAsk.scheduleStatusList = [];

      http
        .request(this.$options.name, "DTS_AIC_00004", {
          data: this.outCallSchedulesAsk,
        })
        .then((response) => {
          // console.log(JSON.stringify(response.data));
          const items = []; // 캠페인 Dropdown 용
          utils.forEach(response.data, (schedule) => {
            items.push({
              text: schedule.scheduleName,
              value: schedule.scheduleId,
            });
            // sipNumber 중복 제거하고 select box 채움
            if (!this.sipNumberSet.has(schedule.sipNumber)) {
              this.sipNumberSet.add(schedule.sipNumber);
              if (!utils.isEmpty(schedule.sipNumberDescription)) {
                this.sipNumberDropdown.push({
                  value: schedule.sipNumber,
                  text:
                    schedule.sipNumber + " | " + schedule.sipNumberDescription,
                });
              } else {
                this.sipNumberDropdown.push({
                  value: schedule.sipNumber,
                  text: schedule.sipNumber,
                });
              }
            }
            // 오름차순 정렬
            this.sipNumberDropdown.sort(function (a, b) {
              return a.value - b.value;
            });
          });
          this.campaignDropdown = items;
          this.campaignValue = items;
          this.statusDropdown = aiccCode.scheduleStatus.valueTextArray;
          this.statusValue = aiccCode.scheduleStatus.valueTextArray;

          // console.log('this.campaignValue', this.campaignValue)
          // 화면을 처음 진입한 경우나 캠페인 등록,복사,삭제 작업후에는 하단 리스트 목록까지 갱신한다.
          if (this.isFirstTime) {
            // this.campaignValue = [];
            // this.statusValue = [];
            this.sipNumberValue = "";
            this.getOutCallScheduleList();
          }
        })
        .catch((error) => {
          console.warn(error);
        });
    },

    getOutCallScheduleList() {
      // 수행일정 validation false시 그냥 리턴한다.
      if (!this.onInputDateCheck()) {
        return;
      }

      // 캠페인 DropDown과 sipNumber dropdown을 채우고 호출하는 경우는 수행일정에만 영향을 받고
      // '조회' 버튼을 누르면 호출하는 경우는 수행일정 + 캠페인 DropDown 선택값 + 상태 DropDown 선택한값 + sipNumber DropDown 선택값의 영향을 받는다.

      this.outCallSchedulesAsk.startDate = utils.toStringByFormat(
        utils.toDate(this.rangeDateValue[0]),
        "YYYYMMDD"
      );
      this.outCallSchedulesAsk.endDate = utils.toStringByFormat(
        utils.toDate(this.rangeDateValue[1]),
        "YYYYMMDD"
      );

      this.outCallSchedulesAsk.scheduleIdList = [];
      this.outCallSchedulesAsk.sipNumberList = [];
      this.outCallSchedulesAsk.scheduleStatusList = [];

      // select box 선택한 값이 있으면 Ask 데이터에 넣는다.
      if (!utils.isEmpty(this.campaignValue) && this.campaignValue.length > 0) {
        for (var schedule of this.campaignValue) {
          this.outCallSchedulesAsk.scheduleIdList.push(schedule.value);
        }
      }

      // console.log('this.statusValue', this.statusValue)
      if (!utils.isEmpty(this.statusValue) && this.statusValue.length > 0) {
        for (var status of this.statusValue) {
          this.outCallSchedulesAsk.scheduleStatusList.push(status.value);
          // 중지(E),취소(F)가 검색 조건에 있는 경우 시스템중지(G), 시스템취소(H)도 같이 가져온다.
          if (status.value === "E") {
            this.outCallSchedulesAsk.scheduleStatusList.push("G");
          }
          if (status.value === "F") {
            this.outCallSchedulesAsk.scheduleStatusList.push("H");
          }
        }
      }
      // console.log('this.outCallSchedulesAsk.scheduleStatusList', this.outCallSchedulesAsk.scheduleStatusList)

      if (this.sipNumberValue === "all") {
        this.outCallSchedulesAsk.sipNumberList = [];
      } else if (this.sipNumberValue) {
        this.outCallSchedulesAsk.sipNumberList.push(this.sipNumberValue);
      }

      // console.log('this.outCallSchedulesAsk', this.outCallSchedulesAsk)

      http
        .request(this.$options.name, "DTS_AIC_00004", {
          data: this.outCallSchedulesAsk,
        })
        .then((response) => {
          // console.log(JSON.stringify(response.data));
          this.setScheduleList(response.data);
        })
        .catch((error) => {
          console.warn(error);
        });
    },

    setScheduleList(responseData) {
      let rowList = []; // 화면용 list
      this.csvDataList = []; //csv 다운로드용 list

      for (var schedule of responseData) {
        // row list 채움
        let row = {};
        row.scheduleId = schedule.scheduleId;
        let schedulePeriod = schedule.startDate + "~" + schedule.endDate;
        row.schedulePeriod = schedulePeriod;
        row.sipNumber = schedule.sipNumber;
        row.scheduleName = schedule.scheduleName;
        row.sipNumber = schedule.sipNumber;
        row.userId = schedule.usrId;
        row.scheduleStatus = schedule.scheduleStatus;
        row.scheduleStatusName = aiccCode.scheduleStatus.codeText(
          schedule.scheduleStatus
        );
        // 시스템중지(G), 시스템취소(H)의 경우 ScheduleStatus.js 에는 없다.
        if (row.scheduleStatus === "G") {
          row.scheduleStatusName = "중지S";
        }
        if (row.scheduleStatus === "H") {
          row.scheduleStatusName = "취소S";
        }
        row.senarioDescription = schedule.scenarioName;
        row.calleeCount = utils.numberFormat(schedule.calleeCount);
        row.scheduleDescription = schedule.scheduleDescription;
        row.insertDate = utils.toStringByFormat(
          schedule.fstRgstDtm,
          "YYYY-MM-DD"
        );
        row.updateDate = utils.toStringByFormat(
          schedule.fnlMdfcDtm,
          "YYYY-MM-DD"
        );
        row.userNm = schedule.usrNm;

        rowList.push(row);

        let csvRow = {};
        let csvSchedulePeriod =
          utils.toStringByFormat(schedule.startDate, "YYYY-MM-DD") +
          "~" +
          utils.toStringByFormat(schedule.endDate, "YYYY-MM-DD");
        csvRow.schedulePeriod = csvSchedulePeriod;
        csvRow.sipNumber = schedule.sipNumber;
        csvRow.scheduleName = schedule.scheduleName;
        csvRow.sipNumber = schedule.sipNumber;
        csvRow.scheduleStatusName = row.scheduleStatusName;
        csvRow.senarioDescription = schedule.scenarioName;
        csvRow.calleeCount = schedule.calleeCount;
        csvRow.scheduleDescription = schedule.scheduleDescription;
        csvRow.insertDate = row.insertDate;
        csvRow.updateDate = row.updateDate;
        csvRow.userNm = schedule.usrNm;
        this.csvDataList.push(csvRow);
      }

      if (responseData.length === 0) {
        this.$nextTick(() => {
          this.scheduleListOptions.msgEmptyData =
            "선택하신 조건의 조회결과가 없습니다.";
          this.$refs["scheduleListGrid"].updateOptions(
            this.scheduleListOptions
          );
          this.$refs["scheduleListGrid"].setData([]);
          // 화면에 처음 진입한 경우나 날짜를 변경한 경우는 isFirstTime이 true이다.
          if (this.isFirstTime) {
            this.clearSearchParams();
          }
        });
      } else {
        this.$nextTick(() => {
          this.scheduleDataList = rowList; // row list를 화면용 list에 넘김
          this.scheduleListOptions.msgEmptyData = "";
          this.$refs["scheduleListGrid"].updateOptions(
            this.scheduleListOptions
          );
          this.buildPages();
        });
      }

      // 화면에 처음 진입한 경우나 날짜를 변경한 경우 하단 목록까지 가져오도록 제어했던 변수를 초기화 한다.
      if (this.isFirstTime) {
        this.isFirstTime = false;
      }
    },

    buildPages() {
      let data = this.scheduleDataList;
      this.page.totalItems = data.length;
      this.page.totalPages = Math.ceil(data.length / this.page.rowsPerPage);
    },

    onInputDateCheck() {
      this.startDateValue = this.rangeDateValue[0];
      this.endDateValue = this.rangeDateValue[1];
      if (utils.isEmpty(this.startDateValue)) {
        this.showSnackbar("시작일자가 빈 값입니다.");
        return false;
      }
      if (utils.isEmpty(this.endDateValue)) {
        this.showSnackbar("종료일자가 빈 값입니다.");
        return false;
      }
      // console.log(utils.getDayOffset(this.endDateValue, this.startDateValue))
      if (utils.getDayOffset(this.endDateValue, this.startDateValue) > 92) {
        this.showSnackbar("검색 가능 일정은 최대 3개월입니다.");
        return false;
      }
      return true;
    },

    registerOutCallSchedule() {
      this.modeValue = "I";
      this.registerPopupWindow = aiccUtils.newOutCallSchedulePopup(
        this.modeValue,
        "",
        (event) => {
          this.showMsgAfterChildClosed();
        }
      );
    },

    moreMenuSelected(value) {
      switch (value.action) {
        case "detail":
          this.showScheduleDetail(value.scheduleInfo);
          break;
        case "copy":
          this.copySchedule(value.scheduleInfo);
          break;
        case "pause":
          this.pauseSchedule(value.scheduleInfo);
          break;
        case "modify":
          this.modifySchedule(value.scheduleInfo);
          break;
        case "delete":
          this.deleteSchedule(value.scheduleInfo);
          break;
        case "replay":
          this.replaySchedule(value.scheduleInfo);
          break;
        case "cancel":
          this.cancelSchedule(value.scheduleInfo);
          break;
      }
    },

    showScheduleDetail(scheduleInfo) {
      // this.pageInitialData = {} 와 같이 초기화 하면 아래에서 값을 셋팅하더라도 props 로 넘어간 데이터는 빈값이 됨(왜 그런지는 ??)
      // console.log(scheduleInfo);
      this.pageInitialData.tabIdx = 1;
      this.pageInitialData.scheduleId = scheduleInfo.scheduleId;
      this.pageInitialData.scheduleName = scheduleInfo.scheduleName;
      this.pageInitialData.scheduleStatus = scheduleInfo.scheduleStatus;
      this.pageInitialData.parentPageId = this.contextPageId;
      this.$refs["scheduleDetailPopup"].open();
    },

    onClosePagePopup() {
      console.log("pagePopup.onClosePagePopup() was called.");
    },

    copySchedule(scheduleInfo) {
      this.modeValue = "C";
      this.copyPopupWindow = aiccUtils.newOutCallSchedulePopup(
        this.modeValue,
        scheduleInfo.scheduleId,
        (event) => {
          this.showMsgAfterChildClosed();
        }
      );
    },

    pauseSchedule(scheduleInfo) {
      // 스케줄 상태: 작성중(A), 대기중(B), 진행중(C), 완료(D), 중지(E), 취소(F)
      this.changeScheduleStatus(
        scheduleInfo.scheduleId,
        scheduleInfo.scheduleName,
        "E"
      );
    },

    onClickMessageBoxCancel() {
      console.log("onClickMessageBoxCancel() was called.");
    },

    modifySchedule(scheduleInfo) {
      // 캠페인이 다른 사용자에 의해 수정 중인지 check 한다.
      this.outCallScheduleAsk.scheduleId = scheduleInfo.scheduleId;
      http
        .request(this.contextPageId, "DTS_AIC_00024", {
          query: this.outCallScheduleAsk,
        })
        .then((response) => {
          // console.log(response.data)
          if (response.data.reply.code !== "0000") {
            console.log(response.data);
            this.showSnackbar(response.data.reply.korMsg);
          } else {
            this.checkWaitingStusAndModifyPopup(scheduleInfo);
          }
        })
        .catch((error) => {
          console.warn(error);
        });
    },

    checkWaitingStusAndModifyPopup(scheduleInfo) {
      this.modeValue = "U";
      // '대기' 캠페인을 수정하는 경우 서버 DB 값이 정말 '대기' 상태인지 확인한다.
      // 즉, 수정 가능한 상태인지 확인하고 '대기' 상태면 '임시저장' 상태로 상태를 바꾼다.
      this.outCallScheduleAsk.scheduleId = scheduleInfo.scheduleId;
      if (scheduleInfo.scheduleStatus === "B") {
        // 수정창에서 '임시저장' -> '대기'로 다시 변경해야 하므로 별도 modeValue로 수정창을 띄운다.
        this.modeValue = "UB";
        // 캠페인 상태가 여전히 '대기'인지 확인한다.
        http
          .request(this.contextPageId, "DTS_AIC_00023", {
            query: this.outCallScheduleAsk,
          })
          .then((response) => {
            if (response.data.reply.code === "0000") {
              // 정상 return 인 경우 대기 상태는 이미 '임시저장'으로 변경된 상태이다.
              this.openModifyPopup(this.modeValue, scheduleInfo.scheduleId);
            } else {
              // 대기 상태가 아니라는 메시지를 보여준다.
              this.showSnackbar(response.data.reply.korMsg);
              // 대기 상태에서 진행 중으로 변경되었기 때문에 캠페인 관리 화면을 갱신한다.
              this.reLoadScheduleList(
                scheduleInfo.scheduleId,
                response.data.scheduleStatus
              );
            }
          })
          .catch((error) => {
            console.warn(error);
          });
      } else {
        this.openModifyPopup(this.modeValue, scheduleInfo.scheduleId);
        console.log("openModifyPopup ", this.modeValue);
      }
    },

    openModifyPopup(modeValue, scheduleId) {
      // 수정모드인 경우 팝업을 scheduleId 당 하나만 띄운다.
      // 윈도우 팝업 중복 방지를 로직 변경
      // 기존 : 팝업시 window 객체 저장 -> 팝업 종료시 window 객체 삭제
      // 변경 : 팝업시 window 객체 저장 -> 팝업 종료시 window 객체 삭제하지 않고 closed 되었는지만 체크
      if (
        !this.updatePopupWindowMap.has(scheduleId) ||
        this.updatePopupWindowMap.get(scheduleId).closed
      ) {
        let updatePopupWindow = aiccUtils.newOutCallSchedulePopup(
          modeValue,
          scheduleId,
          (event) => {
            let params = aiccUtils.getUrlParamMap(event.target.URL);
            let scheduleId = params.scheduleId;
            // this.clearPopupWindowMap(scheduleId);
            this.showMsgAfterChildClosed();
          }
        );
        this.updatePopupWindowMap.set(scheduleId, updatePopupWindow);
      } else {
        let updatePopup = this.updatePopupWindowMap.get(scheduleId);
        updatePopup.focus();
      }
    },

    showMsgAfterChildClosed() {
      // console.log('showMsgAfterChildClosed() was called.');
      // console.log('modeValueFromChild', window.modeValueFromChild)
      // console.log('outCallSchduleInfoFromChild', window.outCallSchduleInfoFromChild)

      if (
        !window.outCallSchduleInfoFromChild ||
        !window.outCallSchduleInfoFromChild.scheduleId
      ) {
        return;
      }

      // 캠페인 상태 변경시에는 modeValueFromChild 값이 'statusChanged'로 넘어오지만
      // CMP_AIC_0005(상세조회 모달)에서 변경되었다는 것을 이미 알려줬기 때문에 여기서는 메시지 보여주지 않고 리스트만 갱신한다.

      let scheduleName = "";
      if (!utils.isEmpty(window.outCallSchduleInfoFromChild.scheduleName)) {
        scheduleName =
          "'" + window.outCallSchduleInfoFromChild.scheduleName + "'";
      }
      if (
        window.modeValueFromChild === "I" ||
        window.modeValueFromChild === "C"
      ) {
        this.showSnackbar(
          utils.strFormat("{0} 캠페인이 등록되었습니다.", scheduleName)
        );
      }
      if (
        window.modeValueFromChild === "U" ||
        window.modeValueFromChild === "UB"
      ) {
        this.showSnackbar(
          utils.strFormat("{0} 캠페인이 수정되었습니다.", scheduleName)
        );
      }
      if (window.modeValueFromChild === "D") {
        this.showSnackbar(
          utils.strFormat("{0} 캠페인이 삭제되었습니다.", scheduleName)
        );
      }

      // 등록/수정화면에서 registerCancelModal 이 뜬 상태에서 '확인'하고 넘어오면
      // modeValueFromChild 값에 'Cancel'이 붙어온다.
      if (window.modeValueFromChild.substr(1, 6) === "Cancel") {
        this.showSnackbar(utils.strFormat("작업이 취소되었습니다."));
      }

      // 캠페인 입력,복사,삭제작업은 조회 대상 캠페인 갯수가 변한 경우이므로 캠페인 Dropdown을 갱신한다.
      // 즉 화면을 처음 진입하는 것처럼 처리한다. 나머지 캠페인 수정,상태변경은 화면 아래 리스트만 갱신한다.
      if (
        window.modeValueFromChild === "I" ||
        window.modeValueFromChild === "C" ||
        window.modeValueFromChild === "D"
      ) {
        this.clearSearchParams();
        this.isFirstTime = true;
        this.getSearchParamsData();
      } else {
        this.getOutCallScheduleList();
      }

      window.modeValueFromChild = "";
      window.outCallSchduleInfoFromChild = "";
    },

    clearPopupWindowMap(scheduleId) {
      // console.log(scheduleId + ' deleted in updatePopupWindowMap.');
      // this.updatePopupWindowMap.delete(scheduleId);
    },

    deleteSchedule(scheduleInfo) {
      // '삭제'버튼이 노출된 상태에서 시간이 경과하여
      // 수행 시작시간이 도래 즉 캠페인이 시작되었을 경우가 발생할 수도 있으므로
      // '삭제' 버튼 클릭 시점에 한번 더 캠페인 상태가 진행 중('C')인지를 한번 더 체크한다.
      this.outCallScheduleAsk.scheduleId = scheduleInfo.scheduleId;
      http
        .request(this.contextPageId, "DTS_AIC_00005", {
          query: this.outCallScheduleAsk,
        })
        .then((response) => {
          if (response.data.scheduleStatus === "C") {
            this.showSnackbar("실행 중인 캠페인은 삭제할 수 없습니다.");
            return;
          } else {
            this.outCallScheduleDeleteAsk["schedule-id"] =
              scheduleInfo.scheduleId;
            // console.log(JSON.stringify(this.outCallScheduleDeleteAsk));
            utils.aiccMessageBox(
              "캠페인 삭제",
              utils.strFormat(
                "<b>{0}</b> 캠페인을 삭제하시겠습니까? \n * 삭제하신 캠페인은 되돌릴 수 없습니다.",
                scheduleInfo.scheduleName
              ),
              "캠페인 삭제",
              () => {
                http
                  .request(this.contextPageId, "DTS_AIC_00015", {
                    path: this.outCallScheduleDeleteAsk,
                  })
                  .then((response) => {
                    if (response.data.reply.code === '0000') {
                      this.showSnackbar(this.$t("MSG_ALT_DELETED"));

                      // 캠페인 작업이 있었으므로 화면 처음 진입하는 것처럼 처리한다.
                      this.isFirstTime = true;
                      this.getSearchParamsData();
                    } else { // 캠페인 삭제시, 서버에서 캠페인 상태를 확인하여 진행이 시작된 캠페인 삭제 불가
                      utils.aiccMessageBox('확인', response.data.reply.korMsg, '확인', null);
                    }
                  })
                  .catch((error) => {
                    console.warn(error);
                  });
              },
              "취소",
              this.onClickMessageBoxCancel()
            );
          }
        })
        .catch((error) => {
          console.warn(error);
        });
    },

    replaySchedule(scheduleInfo) {
      // 스케줄 상태: 작성중(A), 대기중(B), 진행중(C), 완료(D), 중지(E), 취소(F)
      this.changeScheduleStatus(
        scheduleInfo.scheduleId,
        scheduleInfo.scheduleName,
        "C"
      );
    },

    cancelSchedule(scheduleInfo) {
      // 스케줄 상태: 작성중(A), 대기중(B), 진행중(C), 완료(D), 중지(E), 취소(F)
      this.changeScheduleStatus(
        scheduleInfo.scheduleId,
        scheduleInfo.scheduleName,
        "F"
      );
    },

    changeScheduleStatus(scheduleId, scheduleName, scheduleStatus) {
      // 스케줄 상태: 작성중(A), 대기중(B), 진행중(C), 완료(D), 중지(E), 취소(F)
      let messageTitle = "";
      let confirmMessage = "";
      this.outCallScheduleStatusUpdateAsk.scheduleId = scheduleId;
      this.outCallScheduleStatusUpdateAsk.scheduleStatus = scheduleStatus;

      if (scheduleStatus === "E") {
        messageTitle = "중지";
        confirmMessage = utils.strFormat(
          "<b>{0}</b> 캠페인을 중지하시겠습니까?",
          scheduleName
        );
      }
      if (scheduleStatus === "C") {
        messageTitle = "캠페인 다시 진행";
        confirmMessage = utils.strFormat(
          "<b>{0}</b> 캠페인을 다시 진행하시겠습니까?",
          scheduleName
        );
      }
      if (scheduleStatus === "F") {
        messageTitle = "캠페인 취소";
        confirmMessage = utils.strFormat(
          "<b>{0}</b> 캠페인을 취소하시겠습니까?",
          scheduleName
        );
      }

      // 대기 상태 캠페인을 수정시 임시저장(작성중)으로 변경하는 경우로 확인창이나 결과 메시지는 보여주지 않는다.
      if (scheduleStatus === "A") {
        http
          .request(this.contextPageId, "DTS_AIC_00016", {
            data: this.outCallScheduleStatusUpdateAsk,
          })
          .then((response) => {
            if (response.data.reply.code === "0000") {
              console.log("The schedule status is changed to A");
            } else {
              console.warn("The schedule status change is faild.");
            }
          })
          .catch((error) => {
            console.warn(error);
          });
      } else {
        utils.aiccMessageBox(
          messageTitle,
          confirmMessage,
          messageTitle,
          () => {
            http
              .request(this.contextPageId, "DTS_AIC_00016", {
                data: this.outCallScheduleStatusUpdateAsk,
              })
              .then((response) => {
                // console.log(JSON.stringify(response.data));
                if (response.data.reply.code === "0000") {
                  this.showSnackbar("캠페인 상태가 변경되었습니다.");
                } else {
                  this.showSnackbar("캠페인 상태 변경에 실패했습니다.");
                }

                // 캠페인 작업이 있었으므로 화면 처음 진입하는 것처럼 처리한다.
                this.isFirstTime = true;
                this.getSearchParamsData();
              })
              .catch((error) => {
                console.warn(error);
              });
          },
          "취소",
          this.onClickMessageBoxCancel()
        );
      }
    },

    clearSearchParams() {
      this.sipNumberSet = new Set();

      // campaignValue, statusValue, sipNumberValue 를 초기화 하여 '전체' 상태로 만든다.
      this.campaignValue = [];
      this.statusValue = [];
      this.sipNumberValue = "";

      this.campaignDropdown = [];
      this.statusDropdown = [];
      this.sipNumberDropdown = [];
      this.sipNumberDropdown.push({ value: "all", text: "전체" });

      this.outCallSchedulesAsk.scheduleIdList = [];
      this.outCallSchedulesAsk.sipNumberList = [];
      this.outCallSchedulesAsk.scheduleStatusList = [];
    },

    initializeRangePickerValue() {
      let fromDate = utils.dateformatToClient(
        utils.addDay(this.getTodayYmd(), -3),
        "S"
      ); // 3일 전 일자
      let toDate = utils.dateformatToClient(
        utils.addDay(this.getTodayYmd(), 3),
        "S"
      ); // 3일 후 일자
      this.rangeDateValue = [];
      this.rangeDateValue.push(fromDate);
      this.rangeDateValue.push(toDate);
      this.startDateValue = fromDate;
      this.endDateValue = toDate;
    },

    onClickDownload() {
      let startDateValue = this.rangeDateValue[0];
      let endDateValue = this.rangeDateValue[1];
      let campaignValue = "";
      for (var schedule of this.campaignValue) {
        campaignValue =
          campaignValue + schedule.value + " " + schedule.text + ",";
      }
      let statusValue = "";
      for (var status of this.statusValue) {
        statusValue = statusValue + status.value + " " + status.text + ",";
      }
      let sipNumberValue = this.sipNumberValue;

      const sCsvName = `AICC_SCHEDULE_${utils.now("YYYYMMDDHHmmss")}.csv`;
      const fileDownloadHistoryAsk = {
        pageId: this.contextPageId,
        fileName: sCsvName,
        fileDetail: `Campaign period : ${startDateValue}~${endDateValue} / Campaign : ${campaignValue} / Status : ${statusValue} / SipNumber : ${sipNumberValue}`,
      };

      http
        .request(this.contextPageId, "DTS_AIZ_00001", {
          data: fileDownloadHistoryAsk,
        })
        .then((res) => {
          if (res.status === 200) {
            this.onDownloadTableToCsv(this.csvHeaders, sCsvName);
          } else {
            utils.aiccMessageBox(
              "알림",
              "잠시 후 다시 시도해주세요.",
              "확인",
              null
            );
          }
        })
        .catch((error) => {
          console.warn(error);
        });
    },

    onDownloadTableToCsv(headerObj, csvFileNm) {
      var blob, csvUrl, a;
      var csvArray = [];
      // 1. set header
      csvArray.push(headerObj.map((f) => f.text));

      // 2. set Data
      var gridData = this.$refs.csvGrid.getViewData();
      csvArray = csvArray.concat(
        gridData.map((row) => {
          return headerObj.map((f) => {
            return row[f.value];
          });
        })
      );
      csvArray = aiccUtils.stringUtil.enclose2DArrayInDoubleQuotes(csvArray);
      const BOM = "\uFEFF";
      var csvString = BOM + csvArray.map((r) => r.join(",")).join("\r\n");
      blob = new Blob([csvString], { type: "text/csv;charset=utf8" });
      csvUrl = URL.createObjectURL(blob);
      a = document.createElement("a");
      a.setAttribute("style", "display:none");
      a.setAttribute("href", csvUrl);
      a.setAttribute("download", csvFileNm);
      document.body.appendChild(a);
      a.click();
      a.remove();
    },

    getTodayYmd() {
      return utils.now("YYYY-MM-DD");
    },
    getTodayHHmm() {
      return utils.now("HH:mm");
    },
  },
};
</script>

<style scoped>
::v-deep
  .ur-data-grid
  > .ur-data-grid__table
  > .ur-data-grid__content
  > .ur-data-grid__content__scroll-wrapper
  > .ur-data-grid__content__scorll-holder
  > .ur-data-grid__content__row {
  cursor: pointer;
}
::v-deep
  .ur-date-picker.ur-date-picker-range.ur-input.ur-date-picker--medium
  > .ur-date-picker-wrapper
  > .ur-text-field.ur-input.ur-date-picker__text-field.ur-text-field--medium.ur-text-field--border {
  width: 138px;
}
::v-deep
  .ur-date-picker.ur-date-picker-range.ur-input.ur-date-picker--medium
  > .ur-date-picker-wrapper
  > .wave.ur-icon-wrapper {
  width: 24px;
}
</style>